import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RequestStatus} from "../../utils/Enums";
import User from "../../models/User";
import {apiClient} from "../../utils/ApiClient";

export interface LoginPasswordCredentials {
    username: string;
    password: string;
}

interface AuthState {
    loginRequestStatus: RequestStatus;
    loginError: string,
    userData?: User | null
}

const initialState: AuthState = {
    loginRequestStatus: RequestStatus.Idle,
    loginError: '',
    userData: null
}

export const loginPassword = createAsyncThunk("loginPassword", async (credentials: LoginPasswordCredentials, {rejectWithValue}) => {
    const response = await apiClient.post("auth/login", credentials);
    console.log('TEST',response.data);
    return response.data;
});

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.loginError = action.payload;
        },
        logout: () => {
            localStorage.removeItem('token');
        },
        resetLoginStatus: (state) => {
            state.loginRequestStatus = RequestStatus.Idle;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(loginPassword.pending, (state, action) => {
                console.log("login.pending");
                state.loginRequestStatus = RequestStatus.Loading;
                state.loginError = '';
            })
            .addCase(loginPassword.fulfilled, (state, action) => {
                console.log("login.fulfilled", action);
                state.loginRequestStatus = RequestStatus.Success;
                localStorage.setItem('token', action.payload.access_token)
                state.userData = action.payload.userData;
                state.loginError = '';
                window.dispatchEvent(new Event('storage'));
            })
            .addCase(loginPassword.rejected, (state, action) => {
                console.log("login.rejected");
                state.loginRequestStatus = RequestStatus.Failed;
                state.loginError = "Login failed";
            })
    }
});

export const { setError, resetLoginStatus, logout } = authSlice.actions;
export default authSlice.reducer;